import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-ink/50" data-testid="auth-loading">
        <div className="animate-pulse">…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  // License gate — must have at least provisional license to enter the app
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const bypass = path.startsWith("/vouches") || path.startsWith("/vouch/") || adminOnly;
  if (!bypass && user.role !== "admin" && user.license_status === "unlicensed") {
    return <Navigate to="/vouches" replace />;
  }
  if (!adminOnly && !user.onboarded && !path.startsWith("/vouches")) return <Navigate to="/onboarding" replace />;
  return children;
}
